<template>
  <div class="field action-button-field" :style="field.style" v-if="condition">
    <label class="label mb-0">{{ local_value.label || "\u00A0" }}</label>
    <button
      type="button"
      class="button is-small is-info action-button-field__btn"
      :class="{ 'is-loading': loading }"
      :disabled="disabled || loading"
      :title="local_value.button_label || local_value.label || 'Veprim'"
      @click.prevent="onClick"
    >
      <i v-if="local_value.icon" :class="local_value.icon" class="mr-1"></i>
      {{ local_value.button_label || local_value.label || "Veprim" }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["field", "fields"],
  data() {
    return {
      local_value: null,
      loading: false,
    };
  },
  computed: {
    disabled() {
      return !!(this.local_value?.disabled || this.local_value?.readonly);
    },
    condition() {
      let is_visible = true;
      if (this.local_value?.vif && this.fields) {
        this.fields.forEach((f) => {
          const rows = Array.isArray(f) ? f : [f];
          rows.forEach((ff) => {
            this.local_value.vif.forEach((c) => {
              if (ff.name === c.field) {
                if (c.value_not !== undefined) is_visible = ff.value != c.value_not;
                if (c.value !== undefined) is_visible = ff.value == c.value;
              }
            });
          });
        });
      }
      return is_visible;
    },
  },
  watch: {
    field() {
      this.local_value = { ...this.field };
    },
  },
  created() {
    this.local_value = { ...this.field };
  },
  methods: {
    onClick() {
      this.$emit("syncField", { ...this.local_value, _actionTrigger: true });
    },
    setLoading(value) {
      this.loading = value;
    },
  },
};
</script>

<style scoped>
.action-button-field {
  flex: 0 0 auto;
  min-width: 0;
  overflow: visible;
}
.label {
  margin-bottom: 0 !important;
  color: grey;
}
.action-button-field__btn {
  height: 1.75rem;
  min-height: 1.75rem;
  padding: 0 0.55rem;
  font-size: 0.7rem;
  line-height: 1.2;
  white-space: nowrap;
  width: auto;
}
.action-button-field__btn .mr-1 {
  margin-right: 0.25rem !important;
}
</style>
